/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportCatalogFromUrlRequest
 */
export interface ImportCatalogFromUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportCatalogFromUrlRequest
     */
    catalogProvider: ImportCatalogFromUrlRequestCatalogProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof ImportCatalogFromUrlRequest
     */
    catalogUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportCatalogFromUrlRequest
     */
    eraseExistingRecords?: boolean;
}


/**
 * @export
 */
export const ImportCatalogFromUrlRequestCatalogProviderEnum = {
    Glovo: 'glovo',
    Uber: 'uber'
} as const;
export type ImportCatalogFromUrlRequestCatalogProviderEnum = typeof ImportCatalogFromUrlRequestCatalogProviderEnum[keyof typeof ImportCatalogFromUrlRequestCatalogProviderEnum];


/**
 * Check if a given object implements the ImportCatalogFromUrlRequest interface.
 */
export function instanceOfImportCatalogFromUrlRequest(value: object): value is ImportCatalogFromUrlRequest {
    if (!('catalogProvider' in value) || value['catalogProvider'] === undefined) return false;
    if (!('catalogUrl' in value) || value['catalogUrl'] === undefined) return false;
    return true;
}

export function ImportCatalogFromUrlRequestFromJSON(json: any): ImportCatalogFromUrlRequest {
    return ImportCatalogFromUrlRequestFromJSONTyped(json, false);
}

export function ImportCatalogFromUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportCatalogFromUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'catalogProvider': json['catalogProvider'],
        'catalogUrl': json['catalogUrl'],
        'eraseExistingRecords': json['eraseExistingRecords'] == null ? undefined : json['eraseExistingRecords'],
    };
}

export function ImportCatalogFromUrlRequestToJSON(json: any): ImportCatalogFromUrlRequest {
    return ImportCatalogFromUrlRequestToJSONTyped(json, false);
}

export function ImportCatalogFromUrlRequestToJSONTyped(value?: ImportCatalogFromUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'catalogProvider': value['catalogProvider'],
        'catalogUrl': value['catalogUrl'],
        'eraseExistingRecords': value['eraseExistingRecords'],
    };
}

